import { useRoutes } from 'react-router-dom';
import { AboutUs, ContactUs, Custom, PlayTime, Shop } from 'features/misc';
import { publicRoutes } from './public';

export const AppRoutes = () => {
  const commonRoutes = [
    { path: '/', element: <Shop /> },
    { path: '/about', element: <AboutUs /> },
    { path: '/custom', element: <Custom /> },
    { path: '/play-time', element: <PlayTime /> },
    { path: '/contact', element: <ContactUs /> },
  ];

  const routes = publicRoutes;

  const element = useRoutes([...routes, ...commonRoutes]);

  return <>{element}</>;
};
